import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';

export const serviceComputed = {
	...mapState('userGroupManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('userGroupManagementStore', Object.keys(actions)),
	...mapMutations('userGroupManagementStore', Object.keys(mutations))
};
